import { FC } from 'react';
import { Typography, useTheme } from "@mui/material";

const AddToClipboardComponent:FC = () => {
	const theme = useTheme();

	return (
			<Typography sx={{
				px: '20px',
				py: '10px',
				borderRadius: '100px',
				fontFamily: 'Nunito',
				fontWeight: '600',
				fontSize: '24px',
				lineHeight: 1.1,
				color: theme.palette.primary.light,
				backgroundColor: theme.palette.primary.brand
			}}>
				Link was copied successfully
			</Typography>
	)
}

export default AddToClipboardComponent;
